import { Component } from '@angular/core'
import { FileDownloadService } from '@spartacus/storefront'
import { take } from 'rxjs'
import { ImageLibraryService } from '../../../services/account/image-library/image-library.service'

@Component({
    selector: 'app-image-library',
    templateUrl: './image-library.component.html',
    styleUrl: './image-library.component.scss',
    standalone: false
})
export class ImageLibraryComponent {
  public brands: string[] = ['tork', 'tena', 'libra']

  constructor(
    private imageLibrary: ImageLibraryService,
    private fileDownloadService: FileDownloadService
  ) {}

  downloadZip(brand: string) {
    this.imageLibrary
      .getImageLibraryByBrand(brand)
      .pipe(take(1))
      .subscribe((result) => {
        this.fileDownloadService.download(result.url, result.fileName)
      })
  }
}
